import { render, staticRenderFns } from "./UserCourtUpdate.vue?vue&type=template&id=23e37e74"
import script from "./UserCourtUpdate.vue?vue&type=script&lang=js"
export * from "./UserCourtUpdate.vue?vue&type=script&lang=js"
import style0 from "./UserCourtUpdate.vue?vue&type=style&index=0&id=23e37e74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports